module.exports = __webpack_public_path__ + "media/luxury-2026/parsonage-estate-exterior-d9822c9f.jpg";